<section class="bg-secondary">
  <div class="container py-0">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-0 bg-transparent">
        <li class="breadcrumb-item" routerLinkActive="active"><a class="text-light" [routerLink]="['/']">Home</a>
        </li>
        <li class="breadcrumb-item" routerLinkActive="active"><a class="text-light" [routerLink]="['/page']">Sitemap</a>
        </li>
      </ol>
    </nav>
  </div>
</section>

<section class="section my-3">
  <div class="container py-0">

    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="card card-shadow">
          <div class="card-body">

            <div class="ct-page-title">
              <h1 class="ct-title font-weight-normal" id="content">
                <h5 class="text-default fw-bold">Sitemap</h5>
              </h1>
            </div>
            <ul class="list-unstyled treeview">
              <li *ngFor="let item of cmsPages;let i= index">
                <ul class="list-unstyled" *ngIf="item.childCmsPages && item.childCmsPages.length > 0">
                  <ngb-accordion #acc="ngbAccordion" [activeIds]="activeIds">
                    <ngb-panel cardClass="mb-2" id="panel-{{item.id}}">
                      <ng-template ngbPanelHeader let-opened="opened">
                        <div (click)="acc.toggle('panel-' + item.id)" class="d-flex justify-content-start"
                          role="button">
                          <span class="mr-3">
                            <i class="material-icons">
                              {{ opened ? 'indeterminate_check_box' : 'local_hospital' }}
                            </i>
                          </span>
                          <span>{{ item.title }}</span>
                        </div>
                      </ng-template>
                      <ng-template ngbPanelContent>
                        <li *ngFor="let child of item.childCmsPages">
                          <app-child-item [child]="child">
                          </app-child-item>
                        </li>
                      </ng-template>
                    </ngb-panel>
                  </ngb-accordion>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <app-sidebar-links></app-sidebar-links>
      </div>
    </div>
  </div>
</section>